import { VueRegistration } from '@abaco/web-common/src/app';

const globals: VueRegistration = {
    // COMPONENTS
    "PlotTableComponent": () => import("./components/PlotTableComponent.vue"),
    "PlotListComponent": () => import("./components/PlotListComponent.vue"),
    "PortalPlotMapComponent": () => import("./components/PortalPlotMapComponent.vue"),
    "PlotSelectionNavBarItem": () => import("./components/PlotSelectionNavBarItem.vue"),
    "BlockSelectionNavBarItem": () => import("./components/BlockSelectionNavBarItem.vue"),
    "PlotGroupSelectionNavBarItem": () => import("./components/PlotGroupSelectionNavBarItem.vue"),
    "SearchPlotTileButton": () => import("./components/SearchPlotTileButton.vue"),
    "ImportTile": () => import("./components/import/ImportTile.vue"),
    "ImportButton": () => import("./components/import/ImportButton.vue"),
    "PlotAreaInfoCard": () => import("./components/PlotAreaInfoCard.vue")
};

export default globals;
